<mat-sidenav-container autosize>
  <mat-sidenav
    #sidenav
    mode="side"
    [fixedInViewport]="true"
    [fixedTopGap]="40"
    [opened]="true"
  >
    <div class="nav">
      <!--User-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">User</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="['./', USER_ROUTES.PROFILE]"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroUser"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Profile</span>
          }
        </div>
        <div
          class="nav-option"
          [routerLink]="['./', USER_ROUTES.PREFERENCES]"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroAdjustments"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Preferences</span>
          }
        </div>
      </div>

      <!--Platform-->
      <div class="nav-group">
        @if ((sideNav$ | async).expanded) {
          <div class="nav-group-header">
            <div class="nav-group-title">Platform</div>
          </div>
        }
        <div
          class="nav-option"
          [routerLink]="['./', USER_ROUTES.PLATFORM_WORKSPACES]"
          [routerLinkActive]="['active-sidenav-route']"
        >
          <ng-icon name="HeroBriefcase"></ng-icon>
          @if ((sideNav$ | async).expanded) {
            <span>Workspaces</span>
          }
        </div>

        @if (isPlatformAdmin) {
          <div
            class="nav-option"
            [routerLink]="['./', USER_ROUTES.USERS_MANAGEMENT]"
            [routerLinkActive]="['active-sidenav-route']"
          >
            <ng-icon name="HeroUsers"></ng-icon>
            @if ((sideNav$ | async).expanded) {
              <span>Users Management</span>
            }
          </div>
        }
      </div>

      <div class="fill"></div>

      <app-nav-toggler></app-nav-toggler>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-card class="card-base-section">
      <mat-card-header class="card-header">
        <mat-card-title class="card-header-title">Settings</mat-card-title>
      </mat-card-header>
      <div class="card-header-division"></div>
      <router-outlet></router-outlet>
    </mat-card>
  </mat-sidenav-content>
</mat-sidenav-container>
